var React = require('react');

function IconChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.947 5.5 8.5 11.957l6.447 6.438","fill":"none","stroke":"currentColor","strokeWidth":"2"}));
}

IconChevronLeft.defaultProps = {"width":"24","height":"24"};

module.exports = IconChevronLeft;

IconChevronLeft.default = IconChevronLeft;
